import React from "react";
import intl from "react-intl-universal";
import { useParams } from "react-router-dom";
import { useGet } from "restful-react";
import Box from "@material-ui/core/Box";
import Button from "@material-ui/core/Button";
import { useHistory } from "react-router-dom";

import { routing } from "routing";
import { Heading } from "components/Heading";
import { MatchCard } from "components/MatchCard";
import { IMatchResponse, getMatch } from "apis";

import { WithballDataCompare } from "./WithballDataCompare";

const { Urls } = routing;

export const MatchStats = () => {
  const { matchId } = useParams<{ matchId: string }>();
  const history = useHistory();

  const { data: matchResponse } = useGet<IMatchResponse>({
    path: matchId ? getMatch(parseInt(matchId)) : "",
  });

  const handleInputClick = () => {
    history.push(Urls.MATCH_WITHBALL_DATA_INPUT(matchId));
  };

  const handleHomeTeamStatsClick = () => {
    const homeTeam = matchResponse?.match?.homeFullTeam;
    if (homeTeam) {
      history.push(Urls.MATCH_TEAM_STATS(matchId, homeTeam.id));
    }
  };

  const handleAwayTeamStatsClick = () => {
    const awayTeam = matchResponse?.match?.awayFullTeam;
    if (awayTeam) {
      history.push(Urls.MATCH_TEAM_STATS(matchId, awayTeam.id));
    }
  };

  return (
    <>
      <Heading title={intl.get("MATCH_STATS_TITLE")} />
      {matchResponse && <MatchCard match={matchResponse.match} />}
      <Box mt={4} />
      <Heading
        title={intl.get("MATCH_STATS_TECHNICAL_STATISTICS")}
        rightAction={
          <>
            <Button variant="contained" onClick={handleInputClick}>
              {intl.get("MATCH_STATS_DATA_INPUT")}
            </Button>
            <Box display="inline" ml={2} />
            <Button
              variant="contained"
              color="secondary"
              disabled={!matchResponse?.match?.homeFullTeam}
              onClick={handleHomeTeamStatsClick}
            >
              {intl.get("MATCH_STATS_HOME_TEAM_DATA")}
            </Button>
            <Box display="inline" ml={2} />
            <Button
              variant="contained"
              color="secondary"
              disabled={!matchResponse?.match?.awayFullTeam}
              onClick={handleAwayTeamStatsClick}
            >
              {intl.get("MATCH_STATS_AWAY_TEAM_DATA")}
            </Button>
          </>
        }
      />
      <WithballDataCompare
        matchId={matchId}
        homeTeamId={matchResponse?.match.homeFullTeam?.id.toString()}
        awayTeamId={matchResponse?.match.awayFullTeam?.id.toString()}
      />
    </>
  );
};
